import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { RoleOption } from 'src/app/pages/role-register/models/role-option.interface';
import { EagerMultiSelectDataSource } from '../../extension/multi-select/eager-multi-select-data-source';
import { roleOptionActions } from '../state/role-option.actions';
import { roleOptionSelectors } from '../state/role-option.reducer';

export class RoleMultiSelectDataSource extends EagerMultiSelectDataSource<RoleOption> {
   constructor(store: Store<AppState>, filterOverrides: string[]) {
      super(store, roleOptionActions, roleOptionSelectors);
      this.filterOverrides = filterOverrides;
   }

   compareWith(a: RoleOption, b: RoleOption): boolean {
      return a.roleId === b.roleId;
   }
}
